module.exports = __webpack_public_path__ + "static/media/search-doc.b9b16343.svg";